export const datePickerTexts = {
  ErrorValueMinDate: "minDate is not a valid date. If you passed new Date() with an argument, the required date format is new Date('yyyy/MM/dd')",
  ErrorValueMaxDate: "maxDate is not a valid date. If you passed new Date() with an argument, the required date format is new Date('yyyy/MM/dd')",
  InvalidDate: "Fecha invalida",
  DefaultMinDate: "31/12/1899",
  DefaultMaxDate: "01/01/2100",
  MonthYearFormat: "MM/yyyy",
  DayMonthYearFormat: "dd/MM/yyyy",
};

export const datePickerDateRangeErrorTexts = ({ minDate, maxDate }) => ({
  MinDateError: `La fecha seleccionada debe ser posterior al ${minDate}`,
  MaxDateError: `La fecha seleccionada debe ser anterior al ${maxDate}`,
});

